import { useContext } from 'react';
import { styles } from '../../styles';
import { FinancialStatusContext } from './context/financial-status-context';

type ComponentProps = {
	step: number;
};
export default function StepHeader({ step }: ComponentProps) {
	const financialContext = useContext(FinancialStatusContext);

	return (
		<div className={`mb-5 ${styles.pageHeader}`}>
			{financialContext.language === 'en'
				? financialContext.progressSteps[step]?.en
				: financialContext.progressSteps[step]?.es}
		</div>
	);
}
